import { render, staticRenderFns } from "./SmsTemplateMmList.vue?vue&type=template&id=cc072790"
import script from "./SmsTemplateMmList.vue?vue&type=script&lang=js"
export * from "./SmsTemplateMmList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports